const getThreadContentItemByThreadId = (threadContent = [], threadId) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return null;
  }

  const directMatch = threadContent?.[normalizedThreadId];

  if (directMatch && typeof directMatch === 'object') {
    return directMatch;
  }

  if (!Array.isArray(threadContent)) {
    return null;
  }

  return threadContent.find((item) => String(item?.threadId || '').trim() === normalizedThreadId) || null;
};

export default getThreadContentItemByThreadId;
